// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*{
    box-sizing: border-box; 
    -webkit-tap-highlight-color: transparent;
}
html{
    -webkit-text-size-adjust: none; 
    font-size: 4.2666666666vw;
    display: flex;
    flex-direction: column;  
    width: 100%; 
    height: 100%;
    line-height: 1.33;
    background-color: #BEB7FB; 
}  
.ellipse1{
    height: auto;
    width: 39.125em;
    position: absolute;
    top: -7em;
    left: 50%;
    margin-left: -9em;
}
.ellipse2{
    height: auto;
    width: 40.625em;
    position: absolute;
    top: 13em;
    right: 50%;
    margin-right: -12em;
}
body{  
    background-color: #BEB7FB; 
    font-family: 'Roboto';  
    color: #fff;
    font-size: 1rem;
    margin: 0;
    padding: 0;
    flex-grow: 1;
    display: flex; 
    flex-direction: column;  
    position: relative;
} 
#root{ 
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    position: relative;
}
img{
    max-width: 100%;
    height: auto;
}
.preloadedImage{
    width: 1px;
    height: 1px;
    position: absolute;
    pointer-events: none;
    opacity: 0;
    -webkit-user-select: none;
            user-select: none;
    left: -9999px;
    top: -9999px;
}
a{
    color: inherit;
    -webkit-tap-highlight-color: transparent;
    text-decoration: none !important;
    transition: 0.3s opacity, 0.3s background, 0.3s color;
    -webkit-user-select: none;
            user-select: none;
}
button{
    -webkit-user-select: none;
            user-select: none;
    cursor: pointer;
    transition: 0.3s opacity, 0.3s background, 0.3s color;
}
button:active,
a:active{
    opacity: 0.7;
}
button, input{ 
    -webkit-tap-highlight-color: transparent;
    font-size: 1em;
    font-family: 'Roboto';
}
u{ 
    text-decoration: underline;
}

strong{
    font-weight: 700;
} 
p{
    margin: 0;
    padding: 0;
}
b{
    font-weight: 500;
}
.slide-routes{
    width: 100%;
    height: 100%;
}
.item{
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    max-width: 100vw;
} 
.frame{
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    position: relative;
    background-position: top center;
    background-size: cover;
}
.frame__content{
    flex-grow: 1;
}

.logo{
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 1.9em;
}
.logo__left{
    width: 4.5em;
    height: auto;    
    margin: 0 0.05em 0.25em -0.1em;
}
.logo__x{
    width: 0.625em;
    height: auto;
    margin: 0em 1.6em 0.15em;
}
.logo__right{
    width: 9.5em;
    height: auto;
    margin-top: -0.3em;
}
.btn{
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    height: 2.5em;
    font-weight: 500;
    border-radius: 0.75em;
    color: #fff;
    font-size: 1em;
    border: none;
    padding: 0;
    background: #FF5317; 
} 
@media(min-width: 100vh){
    html{
        font-size: 1.48148148vh;
        overflow: hidden; 
    }
    body{
        overflow: hidden; 
    } 
    .ellipse1{
        width: 103em;
        top: -38em; 
        margin-left: -3em;
    }
    .ellipse2{
        width: 103em;
        top: -2em; 
        margin-right: -5em;
    }
    .btn{
        height: 3em;
    }
    .btn:hover{
        background: #454545;
    } 
    .logo{
        margin-top: 4.45em;
    }
    .logo__left{
        width: 8.375em;
        margin: 0 -0.15em 0.35em 0em;
    }
    .logo__x{
        width: 1.1625em;
        margin: 0em 3.05em 0.15em;
    }
    .logo__right{
        width: 17.875em;
        margin-right: -0.1em;
        margin-left: 0.1em;
    }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,wCAAwC;AAC5C;AACA;IACI,8BAA8B;IAC9B,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,yBAAyB;AAC7B;AACA;IACI,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,iBAAiB;AACrB;AACA;IACI,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,mBAAmB;AACvB;AACA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,WAAW;IACX,eAAe;IACf,SAAS;IACT,UAAU;IACV,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB;AACA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,YAAY;AAChB;AACA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,oBAAoB;IACpB,UAAU;IACV,yBAAiB;YAAjB,iBAAiB;IACjB,aAAa;IACb,YAAY;AAChB;AACA;IACI,cAAc;IACd,wCAAwC;IACxC,gCAAgC;IAChC,qDAAqD;IACrD,yBAAiB;YAAjB,iBAAiB;AACrB;AACA;IACI,yBAAiB;YAAjB,iBAAiB;IACjB,eAAe;IACf,qDAAqD;AACzD;AACA;;IAEI,YAAY;AAChB;AACA;IACI,wCAAwC;IACxC,cAAc;IACd,qBAAqB;AACzB;AACA;IACI,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,SAAS;IACT,UAAU;AACd;AACA;IACI,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,+BAA+B;IAC/B,sBAAsB;AAC1B;AACA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;AACrB;AACA;IACI,YAAY;IACZ,YAAY;IACZ,8BAA8B;AAClC;AACA;IACI,cAAc;IACd,YAAY;IACZ,wBAAwB;AAC5B;AACA;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,qBAAqB;IACrB,WAAW;IACX,cAAc;IACd,YAAY;IACZ,UAAU;IACV,mBAAmB;AACvB;AACA;IACI;QACI,uBAAuB;QACvB,gBAAgB;IACpB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,YAAY;QACZ,UAAU;QACV,iBAAiB;IACrB;IACA;QACI,YAAY;QACZ,SAAS;QACT,kBAAkB;IACtB;IACA;QACI,WAAW;IACf;IACA;QACI,mBAAmB;IACvB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,cAAc;QACd,4BAA4B;IAChC;IACA;QACI,eAAe;QACf,yBAAyB;IAC7B;IACA;QACI,eAAe;QACf,oBAAoB;QACpB,kBAAkB;IACtB;AACJ","sourcesContent":["*{\n    box-sizing: border-box; \n    -webkit-tap-highlight-color: transparent;\n}\nhtml{\n    -webkit-text-size-adjust: none; \n    font-size: 4.2666666666vw;\n    display: flex;\n    flex-direction: column;  \n    width: 100%; \n    height: 100%;\n    line-height: 1.33;\n    background-color: #BEB7FB; \n}  \n.ellipse1{\n    height: auto;\n    width: 39.125em;\n    position: absolute;\n    top: -7em;\n    left: 50%;\n    margin-left: -9em;\n}\n.ellipse2{\n    height: auto;\n    width: 40.625em;\n    position: absolute;\n    top: 13em;\n    right: 50%;\n    margin-right: -12em;\n}\nbody{  \n    background-color: #BEB7FB; \n    font-family: 'Roboto';  \n    color: #fff;\n    font-size: 1rem;\n    margin: 0;\n    padding: 0;\n    flex-grow: 1;\n    display: flex; \n    flex-direction: column;  \n    position: relative;\n} \n#root{ \n    flex-grow: 1;\n    display: flex;\n    flex-direction: column;\n    position: relative;\n}\nimg{\n    max-width: 100%;\n    height: auto;\n}\n.preloadedImage{\n    width: 1px;\n    height: 1px;\n    position: absolute;\n    pointer-events: none;\n    opacity: 0;\n    user-select: none;\n    left: -9999px;\n    top: -9999px;\n}\na{\n    color: inherit;\n    -webkit-tap-highlight-color: transparent;\n    text-decoration: none !important;\n    transition: 0.3s opacity, 0.3s background, 0.3s color;\n    user-select: none;\n}\nbutton{\n    user-select: none;\n    cursor: pointer;\n    transition: 0.3s opacity, 0.3s background, 0.3s color;\n}\nbutton:active,\na:active{\n    opacity: 0.7;\n}\nbutton, input{ \n    -webkit-tap-highlight-color: transparent;\n    font-size: 1em;\n    font-family: 'Roboto';\n}\nu{ \n    text-decoration: underline;\n}\n\nstrong{\n    font-weight: 700;\n} \np{\n    margin: 0;\n    padding: 0;\n}\nb{\n    font-weight: 500;\n}\n.slide-routes{\n    width: 100%;\n    height: 100%;\n}\n.item{\n    flex-grow: 1;\n    display: flex;\n    flex-direction: column;\n    max-width: 100vw;\n} \n.frame{\n    flex-grow: 1;\n    display: flex;\n    flex-direction: column;\n    position: relative;\n    background-position: top center;\n    background-size: cover;\n}\n.frame__content{\n    flex-grow: 1;\n}\n\n.logo{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-top: 1.9em;\n}\n.logo__left{\n    width: 4.5em;\n    height: auto;    \n    margin: 0 0.05em 0.25em -0.1em;\n}\n.logo__x{\n    width: 0.625em;\n    height: auto;\n    margin: 0em 1.6em 0.15em;\n}\n.logo__right{\n    width: 9.5em;\n    height: auto;\n    margin-top: -0.3em;\n}\n.btn{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n    height: 2.5em;\n    font-weight: 500;\n    border-radius: 0.75em;\n    color: #fff;\n    font-size: 1em;\n    border: none;\n    padding: 0;\n    background: #FF5317; \n} \n@media(min-width: 100vh){\n    html{\n        font-size: 1.48148148vh;\n        overflow: hidden; \n    }\n    body{\n        overflow: hidden; \n    } \n    .ellipse1{\n        width: 103em;\n        top: -38em; \n        margin-left: -3em;\n    }\n    .ellipse2{\n        width: 103em;\n        top: -2em; \n        margin-right: -5em;\n    }\n    .btn{\n        height: 3em;\n    }\n    .btn:hover{\n        background: #454545;\n    } \n    .logo{\n        margin-top: 4.45em;\n    }\n    .logo__left{\n        width: 8.375em;\n        margin: 0 -0.15em 0.35em 0em;\n    }\n    .logo__x{\n        width: 1.1625em;\n        margin: 0em 3.05em 0.15em;\n    }\n    .logo__right{\n        width: 17.875em;\n        margin-right: -0.1em;\n        margin-left: 0.1em;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
